import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CampaignPage } from "@/features/campaigns/CampaignPage";
import { CAMPAIGN_TABS } from "@/features/campaigns/route-params";

const search = z.object({ tab: z.enum(CAMPAIGN_TABS).optional() });

export const Route = createFileRoute("/_app/campaigns/$campaign")({
  validateSearch: search,
  component: Page,
});

function Page() {
  const { campaign } = Route.useParams();
  const { tab } = Route.useSearch();
  return <CampaignPage id={campaign} tab={tab ?? "email"} />;
}
